import translator from "@/translator";
import React from "react";
import Logo from "@/note_office/icons/Logo";
import { Button } from "antd";

const t = translator("note_office.views.onboarding.index_view.");

const IndexView = ({ onboardingData }) => {
  return (
    <div className="wrapper overflow onboarding__index">
      <div className="onboarding">
        <div className="onboarding__container">
          <div className="onboarding__logo">
            <Logo className="onboarding__logo-svg" />
          </div>

          <h1 className="onboarding__title">{t("welcome_title")}</h1>

          <div className="onboarding__description">
            <p dangerouslySetInnerHTML={{ __html: t("description_1_html") }} />
            <p dangerouslySetInnerHTML={{ __html: t("description_2_html") }} />
            <p dangerouslySetInnerHTML={{ __html: t("description_3_html") }} />
          </div>
        </div>

        <Button className="button-base" type="primary" href={onboardingData.contacts_url}>
          {t("start_button")}
        </Button>
      </div>
    </div>
  );
};

export default IndexView;
